<template>
  <section
    class="deck deck--grey site-notification is-shown"
    :class="{'site-notification--icon' : icon}">
    <div class="site-notification__close" v-if="closable">
      <a href="javascrip:;" @click="doClose">
        <Icon name="svg-icon-close" id="close"></Icon>
      </a>
    </div>
    <div class="w--normal">
      <article class="site-notification__inner width-limit">
        <div v-if="icon" class="site-notification__icon">
          <Icon name="skybrud" id="skybrud"></Icon>
          <svg class="svg-icon" :class="['svg-icon-' + icon ]">
              <use :xlink:href="['/themes/custom/tryg/dist/svg/svg-sprite.svg#' + icon ]"></use>
          </svg>
        </div>
        <div class="site-notification__content">
          <h2 class="site-notification__headline">{{headline}}</h2>
          <p class="site-notification__body">{{bodyText}}</p>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import Icon from '@/components/common/Icon'

export default {
  name: 'SiteNotification',
  components: {
    Icon
  },
  props: {
    closable: {
      type: Boolean,
      default: true
    },
    headline: {
      type: String,
      default: ''
    },
    bodyText: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: null
    }
  },
  data: function () {
    return { }
  },
  methods: {
    doClose () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SiteNotification.vue